export default "__VITE_ASSET__CzuPhW3S__"